import React, { useState, useEffect } from "react";
import CreateNewRecipientButton from "./CreateNewRecipientButton";

import _ from "lodash";
import Loader from "react-loader-spinner";
import CreateNotificationPopup from "../../components/CreateRecipientPopup";
import DeleteNotificationOption from "../../components/DeleteRecipientOption";
import useGetNotifications from "../../hooks/Order/useGetNotificationRecipients";
import useCreateRecipient from "../../hooks/Order/useCreateRecipient";
import useUpdateRecipient from "../../hooks/Order/useUpdateRecipient";
import { icons } from "../../images";
import useDeleteRecipient from "../../hooks/Order/useDeleteRecipient";
import { NotificationPopup } from "../../components";

export default function ManageRecipients() {
  const [showModal, setShowModal] = useState(false);
  const [editNotification, setEditNotification] = useState(null);

  const { createNotification, createNotificationStatus } = useCreateRecipient();
  const { updateRecipient, updateRecipientStatus } = useUpdateRecipient();
  const { delete: deleteSubscriber, deleteStatus } = useDeleteRecipient();

  const handleSave = async (notification) => {
    if (editNotification) {
      await updateRecipient({
        recipientId: editNotification.recipientId,
        payload: notification,
      });
    } else {
      await createNotification({
        payload: notification,
      });
    }

    setShowModal(false);
    setEditNotification(null);
  };

  const handleEditClick = (notification) => {
    setEditNotification(notification);
    setShowModal(true);
  };

  function handleDeleteSubscriber(id) {
    deleteSubscriber({ id });
  }

  const { data: preferences, isLoading } = useGetNotifications();

  const successMessage =
    updateRecipientStatus.status === "success"
      ? "Subscription updated successfully"
      : createNotificationStatus.status === "success"
      ? "Subscription created successfully"
      : deleteStatus.status === "success"
      ? "Subscripton deleted successfully"
      : false;
  return (
    <div className="">
      <NotificationPopup
        message={successMessage}
        visible={successMessage}
        closeModal={() => {
          updateRecipientStatus.reset();
          createNotificationStatus.reset();
          deleteStatus.reset();
        }}
        type={"success"}
      />
      <div className="tw-flex tw-items-center tw-gap-4">
        <h3 className="tw-mb-6">Manage Subscription</h3>
        <CreateNewRecipientButton
          onClick={() => {
            setEditNotification(null);
            setShowModal(true);
          }}
        />
      </div>

      {showModal && (
        <CreateNotificationPopup
          key={
            editNotification ? editNotification.id : showModal ? "yes" : "no"
          }
          visible={showModal}
          onClose={() => setShowModal(false)}
          onSave={handleSave}
          notification={editNotification}
          loading={
            createNotificationStatus.status === "loading" ||
            updateRecipientStatus.status === "loading"
          }
          error={
            createNotificationStatus.error?.response?.data?.errors[0]
              ?.message ??
            updateRecipientStatus.error?.response?.data?.errors[0]?.message ??
            deleteStatus.error?.response?.data?.errors[0]?.message ??
            undefined
          }
        />
      )}

      <div className="tw-bg-white tw-mb-4 table-wrapper">
        <div
          className="tw-overflow-auto"
          style={{ maxHeight: "calc(100vh - 330px)" }}
        >
          <table className="tw-min-w-full user-table">
            <thead className="tw-pb-6">
              <tr className="">
                <th
                  className="tw-px-3 tw-whitespace-nowrap tw-pt-3 tw-pb-6 tw-border-b tw-border-gray-200 tw-bg-gray-50 tw-text-left tw-text-xs tw-leading-4 tw-font-semibold tw-text-gray-900 tw-tracking-wider tw-cursor-pointer tw-underline col-sort-header"
                  style={{
                    position: "relative",
                  }}
                >
                  <div className="tw-w-3/4 tw-inline-block">First Name</div>
                </th>

                <th
                  className="tw-px-3 tw-whitespace-nowrap tw-pt-3 tw-pb-6 tw-border-b tw-border-gray-200 tw-bg-gray-50 tw-text-left tw-text-xs tw-leading-4 tw-font-semibold tw-text-gray-900 tw-tracking-wider tw-cursor-pointer tw-underline col-sort-header"
                  style={{
                    position: "relative",
                  }}
                >
                  <div className="tw-w-3/4 tw-inline-block">Last Name</div>
                </th>

                <th
                  className="tw-px-3 tw-pt-3 tw-pb-6 tw-border-b tw-border-gray-200 tw-bg-gray-50 tw-text-left tw-text-xs tw-leading-4 tw-font-semibold tw-text-gray-900 tw-tracking-wider tw-cursor-pointer tw-underline col-sort-header"
                  style={{
                    position: "relative",
                  }}
                >
                  <div className="tw-w-3/4 tw-inline-block">Email</div>
                </th>

                <th
                  className="tw-px-3 tw-pt-3 tw-pb-6 tw-border-b tw-border-gray-200 tw-bg-gray-50 tw-text-left tw-text-xs tw-leading-4 tw-font-semibold tw-text-gray-900 tw-tracking-wider tw-cursor-pointer tw-underline col-sort-header"
                  style={{
                    position: "relative",
                  }}
                >
                  <div className="tw-w-3/4 tw-inline-block">Phone</div>
                </th>

                <th
                  className="tw-px-3 tw-pt-3 tw-text-center tw-pb-6 tw-border-b tw-border-gray-200 tw-bg-gray-50 tw-text-xs tw-leading-4 tw-font-semibold tw-text-gray-900 tw-tracking-wider tw-cursor-pointer tw-underline col-sort-header"
                  style={{
                    position: "relative",
                  }}
                >
                  <div className="tw-w-3/4 tw-inline-block">
                    Subscription count
                  </div>
                </th>

                <th
                  className="tw-px-3 tw-pt-3 tw-pb-6 tw-border-b tw-border-gray-200 tw-bg-gray-50 tw-text-left tw-text-xs tw-leading-4 tw-font-semibold tw-text-gray-900 tw-tracking-wider tw-cursor-pointer tw-underline col-sort-header"
                  style={{
                    position: "relative",
                  }}
                >
                  <div className="tw-w-3/4 tw-inline-block"></div>
                </th>
              </tr>
            </thead>

            <tbody className="tw-bg-white">
              {!isLoading && _.isEmpty(preferences) && (
                <tr>
                  <td colSpan="5">
                    <div className="loader-container  tw-flex tw-items-center tw-justify-center tw-py-10">
                      <h4>No notification to display</h4>
                    </div>
                  </td>
                </tr>
              )}
              {isLoading && (
                <tr>
                  <td colSpan="5">
                    <div className="loader-container  tw-flex tw-items-center tw-justify-center tw-py-10">
                      <Loader
                        type="Oval"
                        color="rgba(246,130,32,1)"
                        height="50"
                        width="50"
                      />
                    </div>
                  </td>
                </tr>
              )}

              {preferences?.map((notification, index) => (
                <React.Fragment key={index}>
                  <tr className="hover:tw-bg-tosca-alice-blue hover:tw-text-gray-900">
                    <td className="tw-px-3 tw-py-4 tw-border-b tw-font-light">
                      {notification.firstName}
                    </td>
                    <td className="tw-px-3 tw-py-4 tw-border-b tw-font-light">
                      {notification.lastName}
                    </td>
                    <td className="tw-px-3 tw-py-4 tw-border-b tw-font-light">
                      {notification.email}
                    </td>
                    <td className="tw-px-3 tw-py-4 tw-border-b tw-font-light">
                      {notification.phoneNumber}
                    </td>
                    <td className="tw-px-3 tw-py-4 tw-border-b tw-font-light tw-text-center">
                      {notification.subscriptions?.length}
                    </td>
                    <td className="tw-px-3 tw-py-4 tw-border-b tw-font-light">
                      <div className="tw-flex tw-gap-4 tw-justify-end">
                        <button
                          type="button"
                          onClick={() => handleEditClick(notification)}
                          className="tw-bg-transparent tw-flex tw-items-center hover:tw-opacity-50"
                        >
                          <img
                            className="edit-user"
                            src={icons.editIcon}
                            alt="Edit"
                          />
                        </button>

                        <DeleteNotificationOption
                          onConfirm={() =>
                            handleDeleteSubscriber(notification?.recipientId)
                          }
                        />
                      </div>
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
